module.exports = __webpack_public_path__ + "img/crown.95e57fc8.svg";